document.addEventListener("turbo:load", function () {
  if ($('form.warnung-bei-verlassen').length > 0) {
    window.onload = function () {
      window.addEventListener("beforeunload", function (e) {
        return $('form.warnung-bei-verlassen').data('warnungBeimVerlassenText');
      });
    };
  }
});
